import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, TextField, Tabs, Tab } from '@mui/material';

export default function TrialRequestsPage() {
  const [requests, setRequests] = useState([]);
  const [stats, setStats] = useState({pending:0, approved:0, rejected:0, blocked:0, all:0});
  const [attemptNums, setAttemptNums] = useState({});
  const [tab, setTab] = useState('pending');
  const [responses, setResponses] = useState({});
  const [days, setDays] = useState({});
  const [msg, setMsg] = useState('');
  const tok = localStorage.getItem('dashboard_token');

  const load = () => {
    fetch('/api/trial-requests?status='+tab, { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(async d=>{
        setRequests(d || []);
        // Завантажуємо номери спроб
        const nums = {};
        for(const r of (d || [])) {
          try {
            const a = await fetch(`/api/trial-requests/${r.id}/attempt-number`, { headers:{ Authorization:'Bearer '+tok }});
            const aj = await a.json();
            nums[r.id] = aj.attempt || 1;
          } catch(e) { nums[r.id] = 1; }
        }
        setAttemptNums(nums);
      });
    fetch('/api/trial-requests/stats', { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(d=>setStats(d || {pending:0,approved:0,rejected:0,blocked:0,all:0}));
  };

  useEffect(() => { load(); }, [tab]);

  const del = async (id) => {
    if(!confirm('Видалити запит назавжди?')) return;
    const r = await fetch('/api/trial-requests/'+id, { method:'DELETE', headers:{ Authorization:'Bearer '+tok } });
    if(r.ok){ setMsg('🗑 Видалено'); setTimeout(()=>setMsg(''),3000); load(); }
  };
  const restore = async (id) => {
    const r = await fetch('/api/trial-requests/'+id+'/restore', { method:'POST', headers:{ Authorization:'Bearer '+tok } });
    if(r.ok){ setMsg('🔄 Повернуто в Очікують'); setTimeout(()=>setMsg(''),3000); load(); }
  };

  const respond = async (id, action) => {
    const message = responses[id] || '';
    const trialDays = days[id] || 3;
    const r = await fetch(`/api/trial-requests/${id}/respond?action=${action}&message=${encodeURIComponent(message)}&trial_days=${trialDays}`, {
      method:'POST', headers:{ Authorization:'Bearer '+tok }
    });
    if(r.ok){ setMsg('✅ Виконано'); setTimeout(()=>setMsg(''),3000); load(); }
  };

  return (
    <Box sx={{p:3}}>
      <Typography variant="h5" sx={{color:'#FFD700',mb:3}}>📩 Запити на Trial</Typography>

      <Tabs value={tab} onChange={(e,v)=>setTab(v)} sx={{mb:2,'& .MuiTab-root':{color:'#aaa'},'& .Mui-selected':{color:'#FFD700'}}}>
        <Tab value="pending" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>⏳ Очікують</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.pending}</Typography></Box>}/>
        <Tab value="approved" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>✅ Схвалені</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.approved}</Typography></Box>}/>
        <Tab value="rejected" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>❌ Відхилені</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.rejected}</Typography></Box>}/>
        <Tab value="blocked" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>🚫 Заблоковані</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.blocked}</Typography></Box>}/>
        <Tab value="all" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>📋 Всі</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.all}</Typography></Box>}/>
      </Tabs>

      {msg && <Typography sx={{color:'#4caf50',mb:2}}>{msg}</Typography>}

      {requests.length === 0 ? (
        <Paper sx={{bgcolor:'#1a1a2e',p:3,textAlign:'center',color:'#aaa'}}>Немає запитів</Paper>
      ) : requests.map(r => (
        <Paper key={r.id} sx={{bgcolor:'#1a1a2e',border: (attemptNums[r.id] >= 2) ? '2px solid #f44' : '1px solid #FFD700',p:2,mb:2}}>
          <Box sx={{display:'flex',justifyContent:'space-between',mb:1}}>
            <Typography sx={{color:'#FFD700'}}>👤 @{r.telegram_username || 'user'+r.telegram_id} (ID: {r.telegram_id}) {attemptNums[r.id] >= 2 && <span style={{color:'#f44',marginLeft:8}}>⚠️ #{attemptNums[r.id]} спроба</span>}</Typography>
            <Typography sx={{color:'#aaa',fontSize:12}}>🌐 {r.user_lang} | {r.created_at ? new Date(String(r.created_at).replace(' ','T').replace(/Z?$/,'Z')).toLocaleString() : ''}</Typography>
          </Box>

          <Paper sx={{bgcolor:'#0a0a0a',p:1.5,mb:1}}>
            <Typography sx={{color:'#aaa',fontSize:12,mb:0.5}}>📝 Оригінал:</Typography>
            <Typography sx={{color:'#fff',fontSize:14}}>{r.message_original}</Typography>
            {r.message_translated_uk && r.user_lang !== 'uk' && (
              <>
                <Typography sx={{color:'#aaa',fontSize:12,mt:1,mb:0.5}}>🇺🇦 Переклад:</Typography>
                <Typography sx={{color:'#FFD700',fontSize:14}}>{r.message_translated_uk}</Typography>
              </>
            )}
          </Paper>

          {r.status === 'pending' && (
            <Box>
              <TextField fullWidth multiline rows={2} placeholder="Відповідь юзеру (українською - буде перекладено автоматично)"
                value={responses[r.id]||''} onChange={e=>setResponses({...responses,[r.id]:e.target.value})}
                sx={{mb:1,'& textarea':{color:'#fff'},'& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'}}}/>
              <Box sx={{display:'flex',gap:1,alignItems:'center',flexWrap:'wrap'}}>
                <TextField size="small" type="number" label="Дні trial" value={days[r.id]||3}
                  onChange={e=>setDays({...days,[r.id]:parseInt(e.target.value)||3})}
                  sx={{width:100,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
                <Button variant="contained" onClick={()=>respond(r.id,'approve')} sx={{bgcolor:'#4caf50'}}>✅ Дати Trial</Button>
                <Button variant="outlined" onClick={()=>respond(r.id,'reject')} sx={{borderColor:'#aaa',color:'#aaa'}}>❌ Відхилити</Button>
                <Button variant="outlined" onClick={()=>respond(r.id,'block')} sx={{borderColor:'#f44',color:'#f44'}}>🚫 Заблокувати</Button>
              </Box>
            </Box>
          )}
          {r.admin_response && (
            <Paper sx={{bgcolor:'#0a3a0a',p:1,mt:1}}>
              <Typography sx={{color:'#4caf50',fontSize:13}}>💬 Відповідь: {r.admin_response}</Typography>
            </Paper>
          )}
          <Box sx={{display:'flex',gap:1,mt:1,justifyContent:'flex-end'}}>
            {r.status !== 'pending' && (
              <Button size="small" onClick={()=>restore(r.id)} sx={{color:'#FFD700',borderColor:'#FFD700'}} variant="outlined">🔄 В Очікують</Button>
            )}
            <Button size="small" onClick={()=>del(r.id)} sx={{color:'#f44',borderColor:'#f44'}} variant="outlined">🗑 Видалити</Button>
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
